import * as React from 'react';
import styles from './index.less';
import { connect } from 'dva';
import { CollectionDetailPageModelState, ConnectState } from '@/models/connect';
import { RouteComponentProps } from 'react-router/index';
import { Dispatch } from 'redux';
import useUrlState from '@ahooksjs/use-url-state';
import {
  OnMount_Page_Action,
  OnUnmount_Page_Action,
  ChangeAction,
  OnClickCollectAction,
  Fetch_CollectionItems_Action,
} from '@/models/collectionDetailPage';
import * as AHooks from 'ahooks';
import FComponentsLib from '@freelog/components-lib';
import img_choiceLabel from '@/assets/choice-label@2x.png';
import FTooltip from '@/components/FTooltip';
import FResourceProperties from '@/components/FResourceProperties';
import FResourceOptions from '@/components/FResourceOptions';
import FCoverImage from '@/components/FCoverImage';
import { Pagination, Space } from 'antd';
import FGraph_Tree_Authorization_Resource from '@/components/FAntvG6/FGraph_Tree_Authorization_Resource';
import fGraphTree_Authorization_Resource from '@/components/FAntvG6/fGraphTree_Authorization_Resource';
import FGraph_Tree_Dependency_Resource from '@/components/FAntvG6/FGraph_Tree_Dependency_Resource';
import fGraphTree_Dependency_Resource from '@/components/FAntvG6/fGraphTree_Dependency_Resource';
import FExpandable from './FExpandable';
import FLoadingTip from '@/components/FLoadingTip';
import { FShare } from '@/components/FShare';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FHtmlReactParser from '@/components/FHtmlReactParser';
import {
  history,
  // MicroApp
} from 'umi';
// import { initGlobalState, MicroAppStateActions } from 'qiankun';
import FResourceStatusBadge from '@/components/FResourceStatusBadge';
import fMessage from '@/components/fMessage';
import FIcons from '@/components/FIcons';
import FCollectionItems2 from '@/components/FCollectionItems2';
import FCopyToClipboard from '@/components/FCopyToClipboard';
import FSimpleBar from '@/components/FSimpleBar';
// import FMicroApp_SignResourceToNode from '@/components/FMicroApp_SignResourceToNode';
// import FMicroApp_SignResourceToNode_2 from '@/components/FMicroApp_SignResourceToNode_2';
import FMicroApp_SignResourceToNode_3 from '@/components/FMicroApp_SignResourceToNode_3';
import MicroAppStateActionsMgr from '@/utils/MicroAppStateActionsMgr';

// const state = {
//   // 授权处理器弹窗显示
//   authProcessorShow: false,
//   // 授权方 id
//   licensorId: '',
//   licensorResourceVersion: '',
// };

// const actions: MicroAppStateActions = initGlobalState(state);

interface ResourceDetailsProps extends RouteComponentProps<{ id: string }> {
  dispatch: Dispatch;
  // resourceDetailPage: ResourceDetailPageModelState;
  collectionDetailPage: CollectionDetailPageModelState;
}

function ResourceDetails({ match, dispatch, collectionDetailPage }: ResourceDetailsProps) {
  const ref_ItemsTitle = React.useRef<any>(null);
  const refButton = React.useRef(null);
  const [inViewport] = AHooks.useInViewport(refButton);
  const [state] = useUrlState<{ version: string }>();

  AHooks.useMount(async () => {
    dispatch<OnMount_Page_Action>({
      type: 'collectionDetailPage/onMount_Page',
      payload: {
        resourceID: match.params.id,
        // version: state.version,
      },
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_Page_Action>({
      type: 'collectionDetailPage/onUnmount_Page',
    });
  });

  if (collectionDetailPage.page_State === 'loading') {
    return <FLoadingTip height={'calc(100vh - 140px)'} />;
  }

  async function signNode() {
    await FServiceAPI.User.currentUserInfo();
    const { data, ret, errCode, msg } = await FServiceAPI.Resource.info({
      resourceIdOrName: match.params.id,
    });

    if (ret !== 0 || errCode !== 0) {
      return fMessage(msg, 'error');
    }

    if (data.status !== 1) {
      return fMessage('该资源未上架，无法获取授权。', 'error');
    }

    // actions.setGlobalState({
    //   authProcessorShow: true,
    //   licensorId: collectionDetailPage.resource_ID,
    //   licensorResourceVersion: '1.0.0',
    // });
    MicroAppStateActionsMgr.setState({
      authProcessorShow: true,
      licensorId: collectionDetailPage.resource_ID,
      licensorResourceVersion: '1.0.0',
    });
  }

  return (
    <>
      <FSimpleBar height={'calc(100vh - 70px)'}>
        <div className={styles.styles}>
          <div className={styles.content}>
            <div style={{ height: 40 }} />
            <div
              className={styles.cover}
              style={{
                backgroundImage: 'url(' + collectionDetailPage.resource_Info?.cover + ')',
              }}
            >
              <div />
              <article
                style={{
                  backgroundImage: 'url(' + collectionDetailPage.resource_Info?.cover + ')',
                }}
              />
            </div>
            <div style={{ height: 30 }} />
            <div className={styles.article}>
              <div className={styles.articleLeft}>
                <div className={styles.title}>
                  <FComponentsLib.FTitleText
                    text={
                      collectionDetailPage.resource_Info?.title ||
                      collectionDetailPage.resource_Info?.name.split('/')[1] ||
                      ''
                    }
                    type={'h1'}
                    style={{ wordBreak: 'break-all' }}
                  />
                  <div style={{ height: 20 }} />
                  <div className={styles.resourceName}>
                    <FComponentsLib.FContentText
                      type={'additional2'}
                      style={{ color: '#666' }}
                      text={`${FI18n.i18nNext.t('resourcedetails_authid')}：${
                        collectionDetailPage.resource_Info.name
                      }`}
                    />

                    <div className={styles.copy}>
                      <FCopyToClipboard
                        text={collectionDetailPage.resource_Info.name}
                        title={FI18n.i18nNext.t('nodemgnt_btn_copynodeaddr_tooltip')}
                        iconStyle={{ fontSize: 14 }}
                      />
                    </div>
                  </div>
                  <div style={{ height: 20 }} />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div className={styles.resourceInfo}>
                      <div className={styles.resourceInfoUser}>
                        <img src={collectionDetailPage.resource_Info?.useAvatar || ''} alt={''} />
                        <FComponentsLib.FContentText
                          type={'additional2'}
                          style={{ color: '#666' }}
                          text={collectionDetailPage.resource_Info?.username || ''}
                        />
                      </div>
                      <div style={{ borderLeft: '1px solid #999', height: 14 }} />
                      <FComponentsLib.FContentText
                        type={'additional2'}
                        style={{ color: '#666' }}
                        text={collectionDetailPage.resource_Info?.type.join('/') || ''}
                      />
                    </div>

                    {collectionDetailPage.resource_Info?.isChoice && (
                      <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                        <img src={img_choiceLabel} alt={''} style={{ width: 24, height: 24 }} />
                      </FTooltip>
                    )}
                  </div>
                  {collectionDetailPage.resource_Info.about && (
                    <>
                      <div style={{ height: 25 }} />
                      <FComponentsLib.FContentText
                        text={collectionDetailPage.resource_Info.about}
                        type={'normal'}
                        style={{ wordBreak: 'break-all' }}
                      />
                    </>
                  )}
                  <div style={{ height: 20 }} />
                  <div className={styles.handle}>
                    <div
                      className={styles.handleButton}
                      onClick={() => {
                        dispatch<OnClickCollectAction>({
                          type: 'collectionDetailPage/onClickCollect',
                        });
                      }}
                    >
                      <FIcons.FFavorite
                        style={{ fontSize: 16 }}
                        filled={collectionDetailPage.resource_IsCollected}
                      />
                      <div style={{ width: 2 }} />
                      <span>{collectionDetailPage.resource_IsCollected ? '已收藏' : '收藏'}</span>
                      <div style={{ width: 10 }} />
                      <span>({collectionDetailPage.resource_Popularity}人气)</span>
                    </div>
                    <FShare
                      type='resource'
                      title={collectionDetailPage.resource_Info.title}
                      url={window.location.href}
                      cover={collectionDetailPage.resource_Info.cover}
                      desc={collectionDetailPage.resource_Info.about}
                    >
                      <div
                        className={styles.handleButton}
                        onClick={async () => {
                          await FServiceAPI.Activity.pushMessageTask({
                            taskConfigCode: 'TS000024',
                          });
                        }}
                      >
                        <FIcons.FShare style={{ fontSize: 16 }} />
                        <div style={{ width: 2 }} />
                        <span>分享</span>
                      </div>
                    </FShare>
                  </div>
                </div>

                {!(
                  collectionDetailPage.resourceVersion_Info.description === '' ||
                  collectionDetailPage.resourceVersion_Info.description === '<p></p>'
                ) && (
                  <>
                    <div style={{ height: 5 }} />
                    <div className={styles.version}>
                      <FComponentsLib.FContentText
                        // text={`集合描述`}
                        text={FI18n.i18nNext.t('resourcedetails_collection_descr')}
                        type={'highlight'}
                      />
                      <div style={{ height: 20 }} />
                      <FExpandable dep={'123'}>
                        <FHtmlReactParser
                          str={collectionDetailPage.resourceVersion_Info.description}
                        />
                      </FExpandable>
                    </div>
                  </>
                )}

                <div style={{ height: 5 }} />
                <div className={styles.version}>
                  <div ref={ref_ItemsTitle} />
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <FComponentsLib.FContentText
                      // text={`合集内容`}
                      text={FI18n.i18nNext.t('resourcedetails_collection_items')}
                      type={'highlight'}
                    />
                    {collectionDetailPage.resource_Info.collection?.status === 'finish' && (
                      <label className={[styles.label1, styles.finished].join(' ')}>
                        {/* 已完结 */}
                        {FI18n.i18nNext.t('cqr_itemmgmt_updatedstates_completed')}
                      </label>
                    )}
                    {collectionDetailPage.resource_Info.collection?.status === 'unFinish' && (
                      // <label className={[styles.label1, styles.updating].join(' ')}>连载中</label>)
                      <label className={[styles.label1, styles.updating].join(' ')}>
                        {FI18n.i18nNext.t('cqr_itemmgmt_updatestates_ongoing')}
                      </label>
                    )}
                  </div>

                  {collectionDetailPage.collectionItems.length > 0 && (
                    <>
                      <div style={{ height: 5 }} />
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <FComponentsLib.FContentText
                          text={`${collectionDetailPage.collectionItems_totalCount}个单品`}
                          type={'additional2'}
                        />
                        <FComponentsLib.FContentText
                          text={`最近更新时间 ${collectionDetailPage.resourceVersion_Info.updateDate}`}
                          type={'additional2'}
                        />
                      </div>
                      <div style={{ height: 20 }} />
                      <FCollectionItems2
                        showView={
                          collectionDetailPage.collectionItemsSetting.collection_view ===
                          'collection_view_list'
                            ? 'list'
                            : 'card'
                        }
                        showCover={
                          collectionDetailPage.collectionItemsSetting
                            .collection_item_image_display === 'collection_item_image_display_show'
                            ? 'show'
                            : 'hide'
                        }
                        showNumber={
                          collectionDetailPage.collectionItemsSetting.collection_item_no_display ===
                          'collection_item_no_display_show'
                            ? 'show'
                            : 'hide'
                        }
                        showTitle={
                          collectionDetailPage.collectionItemsSetting.collection_item_title ===
                          'collection_item_title_rtitle'
                            ? 'title'
                            : collectionDetailPage.collectionItemsSetting.collection_item_title ===
                              'collection_item_title_sn'
                            ? 'serial'
                            : collectionDetailPage.collectionItemsSetting.collection_item_title ===
                              'collection_item_title_custom'
                            ? 'customNotEdited'
                            : 'hide'
                        }
                        showIntroduction={
                          collectionDetailPage.collectionItemsSetting
                            .collection_item_descr_display === 'collection_item_descr_display_show'
                            ? 'show'
                            : 'hide'
                        }
                        resources={collectionDetailPage.collectionItems}
                        size={'small'}
                      />
                    </>
                  )}

                  {collectionDetailPage.collectionItems.length === 0 && (
                    <>
                      <div style={{ height: 20 }} />
                      <FComponentsLib.FContentText
                        text={
                          // 未添加单品
                          FI18n.i18nNext.t('resourcedetails_collection_itmes_empty')
                        }
                        type={'additional2'}
                        style={{ color: '#222' }}
                      />
                    </>
                  )}

                  {((collectionDetailPage.collectionItemsSetting.collection_view ===
                    'collection_view_list' &&
                    collectionDetailPage.collectionItems_totalCount > 10) ||
                    (collectionDetailPage.collectionItemsSetting.collection_view ===
                      'collection_view_card' &&
                      collectionDetailPage.collectionItems_totalCount > 6)) && (
                    <>
                      <div style={{ height: 20 }} />

                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Pagination
                          showTitle={false}
                          locale={{
                            // items_per_page: '条/页',
                            items_per_page: FI18n.i18nNext.t(
                              'cqr_itemmgmt_list_pagenation_perpage',
                            ),
                            // jump_to: '前往',
                            jump_to: FI18n.i18nNext.t('cqr_itemmgmt_list_pagenation_currentpage'),
                            // page: '页',
                            page: ' ',
                          }}
                          size='small'
                          showSizeChanger
                          showQuickJumper
                          current={collectionDetailPage.collectionItems_pageCurrent}
                          pageSize={collectionDetailPage.collectionItems_pageSize}
                          total={collectionDetailPage.collectionItems_totalCount}
                          onChange={async (page, pageSize) => {
                            const version_resources_pageCurrent =
                              collectionDetailPage.collectionItems_pageCurrent;
                            await dispatch<ChangeAction>({
                              type: 'collectionDetailPage/change',
                              payload: {
                                collectionItems_pageCurrent: page,
                                collectionItems_pageSize: pageSize,
                              },
                            });
                            await dispatch<Fetch_CollectionItems_Action>({
                              type: 'collectionDetailPage/fetch_CollectionItems',
                            });

                            if (page !== version_resources_pageCurrent) {
                              ref_ItemsTitle.current?.scrollIntoView({
                                behavior: 'smooth',
                                // block: 'end',
                                // inline: 'nearest',
                              });
                            }
                          }}
                          showTotal={(total) => {
                            return FI18n.i18nNext.t('cqr_itemmgmt_list_pagenation_total', {
                              PageCount: total,
                            });
                          }}
                          pageSizeOptions={
                            collectionDetailPage.collectionItemsSetting.collection_view ===
                            'collection_view_card'
                              ? [6, 12, 18, 24, 30]
                              : [10, 20, 30, 40, 50]
                          }
                        />
                      </div>
                    </>
                  )}
                </div>

                {(collectionDetailPage.resourceVersion_Info.rawProperties.length > 0 ||
                  collectionDetailPage.resourceVersion_Info.baseProperties.length > 0) && (
                  <>
                    <div style={{ height: 5 }} />
                    <div className={styles.property}>
                      <FComponentsLib.FContentText text={'基础属性'} type={'highlight'} />
                      <div style={{ height: 20 }} />
                      <FResourceProperties
                        immutableData={collectionDetailPage.resourceVersion_Info.rawProperties}
                        onlyEditValueData={[]}
                        alterableData={collectionDetailPage.resourceVersion_Info.baseProperties}
                        keyMaxWidth={84}
                        valueMaxWidth={190}
                      />
                    </div>
                  </>
                )}

                {collectionDetailPage.resourceVersion_Info.customOptions.length > 0 && (
                  <>
                    <div style={{ height: 5 }} />
                    <div className={styles.configuration}>
                      <FComponentsLib.FContentText text={'可选配置'} type={'highlight'} />
                      <div style={{ height: 20 }} />
                      <FResourceOptions
                        theme={'dark'}
                        dataSource={collectionDetailPage.resourceVersion_Info.customOptions}
                      />
                    </div>
                  </>
                )}
              </div>

              <div className={styles.articleRight}>
                <div className={styles.authorize}>
                  <FComponentsLib.FContentText text={'资源授权方案'} type={'highlight'} />
                  <div style={{ height: 20 }} />
                  <div ref={refButton}>
                    <FComponentsLib.FRectBtn
                      style={{ height: 50, width: 400 }}
                      disabled={collectionDetailPage.resource_Info.error !== ''}
                      onClick={() => {
                        signNode();
                      }}
                    >
                      签约至节点
                    </FComponentsLib.FRectBtn>
                  </div>
                  <div style={{ height: 20 }} />

                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <FComponentsLib.FContentText
                      text={'当前资源'}
                      type={'additional2'}
                      style={{ flexShrink: 0 }}
                    />
                    <div
                      style={{
                        width: '100%',
                        flexShrink: 1,
                        borderTop: '1px solid #E5E7EB',
                      }}
                    />
                  </div>
                  <div style={{ height: 15 }} />
                  <div className={styles.authorizeResource}>
                    <div
                      style={{
                        width: 'fit-content',
                        height: 'fit-content',
                        position: 'relative',
                      }}
                    >
                      <FCoverImage
                        src={collectionDetailPage.resource_Info.cover || ''}
                        width={104}
                        style={{ borderRadius: 4 }}
                      />
                      <div className={styles.Status}>
                        {collectionDetailPage.resource_Info.error !== '' && (
                          <FResourceStatusBadge status={collectionDetailPage.resource_Info.error} />
                        )}

                        {collectionDetailPage.resource_Info.isChoice && (
                          <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                            <img src={img_choiceLabel} alt={''} style={{ width: 24, height: 24 }} />
                          </FTooltip>
                        )}
                      </div>
                    </div>
                    <div className={styles.authorizeResourceRight}>
                      <FComponentsLib.FContentText
                        text={
                          collectionDetailPage.resource_Info.name ||
                          collectionDetailPage.resource_Info.title
                        }
                        type={'highlight'}
                        style={{ wordBreak: 'break-all' }}
                      />
                      <div style={{ height: 5 }} />
                      <Space size={10}>
                        <div className={styles.resourceInfoUser}>
                          <img
                            style={{ width: 20, height: 20 }}
                            src={collectionDetailPage.resource_Info.useAvatar}
                            alt={''}
                          />
                          {collectionDetailPage.resource_Info.isChoice && (
                            <FComponentsLib.FContentText
                              type={'additional2'}
                              style={{ color: '#666' }}
                              text={collectionDetailPage.resource_Info.username}
                            />
                          )}
                        </div>
                        <div style={{ borderLeft: '1px solid #999', height: 14 }} />
                        <FComponentsLib.FContentText
                          type={'additional2'}
                          style={{ color: '#666' }}
                          text={collectionDetailPage.resource_Info.type.join('/')}
                        />
                      </Space>
                      <div style={{ height: 5 }} />
                      {collectionDetailPage.resource_Info.error !== '' && (
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: 12,
                            color: '#E9A923',
                            lineHeight: '18px',
                          }}
                        >
                          无法获取授权
                        </div>
                      )}

                      {collectionDetailPage.resource_Info.error === '' &&
                        collectionDetailPage.resource_Info.warning === 'authException' && (
                          <>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 12,
                                color: '#E9A923',
                                lineHeight: '18px',
                              }}
                            >
                              {FI18n.i18nNext.t('alarm_resource_authorization_abnormal')}
                            </div>
                            <div style={{ height: 5 }} />
                          </>
                        )}

                      {collectionDetailPage.resource_Info.error === '' &&
                        collectionDetailPage.resource_Info.warning === 'ownerFreeze' && (
                          <>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 12,
                                color: '#E9A923',
                                lineHeight: '18px',
                              }}
                            >
                              {FI18n.i18nNext.t('alert_auth_useraccountdisable_resouce')}
                            </div>
                            <div style={{ height: 5 }} />
                          </>
                        )}

                      {collectionDetailPage.resource_Info.error === '' && (
                        <div className={styles.policies}>
                          {collectionDetailPage.resource_Info?.policyTitles.map((pt, ptIndex) => {
                            return (
                              <label key={ptIndex}>
                                <FIcons.FPolicy style={{ fontSize: 14 }} />
                                <span>{pt}</span>
                              </label>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {collectionDetailPage.resource_Info.tags.length > 0 && (
                  <>
                    <div style={{ height: 5 }} />
                    <div className={styles.label}>
                      <FComponentsLib.FContentText text={'标签'} type={'highlight'} />
                      <div style={{ height: 20 }} />
                      <div className={styles.resourceLabels}>
                        {collectionDetailPage.resource_Info.tags.map((label, labelIndex) => {
                          return <label key={labelIndex}>{label}</label>;
                        })}
                      </div>
                    </div>
                  </>
                )}

                {
                  <div
                    style={{
                      display: collectionDetailPage.resourceVersion_authorizationGraphShow
                        ? 'display'
                        : 'none',
                    }}
                  >
                    <div style={{ height: 5 }} />
                    <div className={styles.relationship}>
                      <FComponentsLib.FContentText text={'授权链视图'} type={'highlight'} />
                      <div style={{ height: 20 }} />
                      <div className={styles.ViewportCard}>
                        <div className={styles.Viewport}>
                          <FGraph_Tree_Authorization_Resource
                            resourceID={collectionDetailPage.resource_ID}
                            version={'1.0.0'}
                            width={400}
                            height={120}
                            fit={true}
                            onMount={({ hasData }) => {
                              dispatch<ChangeAction>({
                                type: 'collectionDetailPage/change',
                                payload: {
                                  resourceVersion_authorizationGraphShow: hasData,
                                },
                              });
                            }}
                          />
                        </div>

                        <div className={styles.ViewportCardBottom}>
                          <FComponentsLib.FContentText text={'授权树'} type={'normal'} />
                        </div>

                        <div className={styles.ViewportCardMask}>
                          <a
                            onClick={async () => {
                              await fGraphTree_Authorization_Resource({
                                resourceID: collectionDetailPage.resource_ID,
                                version: '1.0.0',
                              });
                            }}
                          >
                            点击全屏查看
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                {
                  <div
                    style={{
                      display: collectionDetailPage.resourceVersion_dependencyGraphShow
                        ? 'display'
                        : 'none',
                    }}
                  >
                    <div style={{ height: 5 }} />
                    <div className={styles.authorization}>
                      <FComponentsLib.FContentText text={'依赖链视图'} type={'highlight'} />
                      <div style={{ height: 20 }} />

                      <div className={styles.ViewportCard}>
                        <div className={styles.Viewport}>
                          <FGraph_Tree_Dependency_Resource
                            resourceID={collectionDetailPage.resource_ID}
                            version={'1.0.0'}
                            width={400}
                            height={120}
                            fit={true}
                            onMount={({ hasData }) => {
                              dispatch<ChangeAction>({
                                type: 'collectionDetailPage/change',
                                payload: {
                                  resourceVersion_dependencyGraphShow: hasData,
                                },
                              });
                            }}
                          />
                        </div>

                        <div className={styles.ViewportCardBottom}>
                          <FComponentsLib.FContentText text={'依赖树'} type={'normal'} />
                        </div>

                        <div className={styles.ViewportCardMask}>
                          <a
                            onClick={async () => {
                              await fGraphTree_Dependency_Resource({
                                resourceID: collectionDetailPage.resource_ID,
                                version: '1.0.0',
                              });
                            }}
                          >
                            点击全屏查看
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div style={{ height: 140 }} />
          </div>

          {!inViewport && (
            <div className={styles.fixFooter}>
              <div>
                <FComponentsLib.FRectBtn
                  style={{ height: 50, width: 440 }}
                  disabled={collectionDetailPage.resource_Info.error !== ''}
                  onClick={() => {
                    signNode();
                  }}
                >
                  签约至节点
                </FComponentsLib.FRectBtn>
              </div>
            </div>
          )}
        </div>
      </FSimpleBar>
      {collectionDetailPage.user_Logged && (
        <FMicroApp_SignResourceToNode_3
          // signedToNode={(presentableId: string, nodeId: number) => {
          //   history.push(
          //     FUtil.LinkTo.collectionExhibitManagement({
          //       exhibitID: presentableId,
          //     }) + '?openAuthDrawer=true',
          //   );
          // }}
          onSuccess={({ exhibtID, nodeID }) => {
            history.push(
              FUtil.LinkTo.collectionExhibitManagement({ exhibitID: exhibtID }) +
                '?openAuthDrawer=true',
            );
          }}
        />
      )}
    </>
  );
}

export default connect(({ collectionDetailPage }: ConnectState) => ({
  collectionDetailPage,
}))(ResourceDetails);
